
import React, { useState } from "react";

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  fallbackSrc?: string;
  className?: string;
  onError?: () => void;
}

const ImageWithFallback = ({ src, alt, fallbackSrc, className, onError }: ImageWithFallbackProps) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = () => {
    console.log(`Failed to load image: ${src}`);
    setHasError(true);
    setIsLoading(false);
    onError?.();
  };

  const handleLoad = () => {
    setIsLoading(false);
  };

  // If there's an error and no fallback, show a placeholder
  if (hasError && !fallbackSrc) {
    return (
      <div 
        className={`bg-gray-200 dark:bg-gray-700 rounded flex items-center justify-center ${className}`}
        style={{ width: '24px', height: '24px' }}
      >
        <span className="text-xs text-gray-500 dark:text-gray-400">?</span>
      </div>
    );
  }

  return (
    <>
      {isLoading && (
        <div 
          className={`bg-gray-200 dark:bg-gray-700 rounded animate-pulse ${className}`}
          style={{ width: '24px', height: '24px' }}
        />
      )}
      <img
        src={hasError && fallbackSrc ? fallbackSrc : src}
        alt={alt}
        className={`${className} ${isLoading ? 'hidden' : ''}`}
        onError={handleError}
        onLoad={handleLoad}
      />
    </>
  );
};

export default ImageWithFallback;
